<section class="banner">
  <div class="banner-content">
    <div class="banner-girl">
      <img alt="girl" height="532" ngSrc="/assets/images/landing/home/girl.png" width="435" />
    </div>
    <div class="banner-text">
      <h1 class="banner-text__title">{{ 'BANNER.TITLE' | translate }}</h1>
      <div class="banner-girl__mobile">
        <img alt="girl" height="272" ngSrc="/assets/images/landing/home/girl.png" width="236" />
      </div>
      <div class="banner-text__blocks">
        <div class="banner-text__advantages">
          <div class="banner-text__advantages-item">
            <img alt="check" height="42" loading="lazy" ngSrc="/assets/images/landing/home/yellow-check.png" width="42" />
            <span>{{ 'BANNER.ADVANTAGES.TEXT_1' | translate }}</span>
          </div>
          <div class="banner-text__advantages-item">
            <img alt="check" height="42" loading="lazy" ngSrc="/assets/images/landing/home/yellow-check.png" width="42" />
            <span>{{ 'BANNER.ADVANTAGES.TEXT_2' | translate }}</span>
          </div>
        </div>
        <app-button
          (click)="navigateLogin()"
          [img]="{ url: '/assets/images/landing/home/arrow.png', width: '41px', height: '41px' }"
          [label]="'CALCULATE.BTN' | translate"
          color="primary"
          direction="reverse"
          size="w100"
        ></app-button>
      </div>
    </div>
  </div>
</section>
